import { useQuery } from "@tanstack/react-query";
import { InferResponseType } from "hono";
import { client } from "@/lib/hono";
import type { AvatarWithLooks } from "../types";

export type GetAvatarsResponseType = InferResponseType<
    (typeof client.api.avatars.heygen.avatars)["$get"],
    200
>;

export const useGetAvatars = (initialData?: AvatarWithLooks[]) => {
    return useQuery<AvatarWithLooks[]>({
        queryKey: ["avatars"],
        queryFn: async () => {
            const response = await client.api.avatars.heygen.avatars.$get();
            if (!response.ok) throw new Error("Failed to load avatars");
            const json = await response.json();
            return json.data.avatars as AvatarWithLooks[];
        },
        initialData,
    });
};
